import { usePathname } from 'next/navigation'

import { useAuth } from '~/context/AuthProvider'
import { useActiveOrg } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'
import { useSmartAccounts } from '~/hooks/useSmartAccounts'
import { useTransactions } from '~/hooks/useTransactions'
import { OrgSmartAccount } from '~/types'
import { isPublicPage } from '~/utils/isPublicPage'

export const useCommandMenuAvailability = () => {
  const { onboarding, globalModalState } = useAuth()
  const { user } = useAuthUser()
  const { org } = useActiveOrg()
  const { smartAccounts } = useSmartAccounts()
  const { transactions, isInitialLoading } = useTransactions({ hideDust: true })
  const pathname = usePathname()

  const treasuryAddress = smartAccounts.find(
    (account: OrgSmartAccount) => account.role === 'TREASURY',
  )?.address

  const isGettingStartedState =
    !transactions?.length && !!org && !!treasuryAddress && !isInitialLoading

  const isEnabled =
    !!user &&
    !onboarding.isOnboarding &&
    !isGettingStartedState &&
    // Only disable on public pages when not viewing in a dialog
    (!isPublicPage(pathname) || globalModalState.isOpen)

  return { isEnabled }
}
